export const DataGridPageSize:number = 5;